import * as types from '../constants/ActionTypes'
import {handleActions} from 'redux-actions'

const reducers = {}


reducers[types.GET_COMPANY_DETAILS] = (state, action) => {
	return Object.assign({}, state, {
		companyName: action.payload && action.payload.company && action.payload.company.name ? action.payload.company.name : '',
		welcomeExpression: action.payload && action.payload.company && action.payload.company.welcomeExpression ? action.payload.company.welcomeExpression : '',
		timeoutExpression:  action.payload && action.payload.company && action.payload.company.timeoutExpression ? action.payload.company.timeoutExpression : '',
		waitTime:  action.payload && action.payload.company && action.payload.company.waitTime ? action.payload.company.waitTime : '',
		website: action.payload && action.payload.company && action.payload.company.website ? action.payload.company.website : '',
		id: action.payload && action.payload.company && action.payload.company.id ? action.payload.company.id : '',
	})
}

reducers[types.SAVE_COMPANY_EXPRESSION] = (state, action) => {
	if (action.error) {
		return state
	} else {
		return Object.assign({}, state, {
			companyName: action.payload.company.name,
			welcomeExpression: action.payload.company.welcomeExpression,
			timeoutExpression: action.payload.company.timeoutExpression,
			waitTime: action.payload.company.waitTime,
            website:action.payload.company.website
		})
    }
}

export default handleActions(reducers, {})
